const S = {
  wrapper: { marginTop:'10px', padding:'40px', border:'3px solid grey', fontFamily:"'Georgia', serif", color:'#1a1a2e', lineHeight:'1.7' },
  h1: { fontSize:'2rem', fontWeight:'700', borderBottom:'3px solid #2E75B6', paddingBottom:'8px', marginBottom:'24px', color:'#1F3864' },
  h2: { fontSize:'1.3rem', fontWeight:'700', color:'#2E75B6', marginTop:'36px', marginBottom:'12px', borderLeft:'4px solid #2E75B6', paddingLeft:'10px' },
  p: { marginBottom:'12px', fontSize:'0.97rem' },
  infoBox: { background:'#EBF3FB', border:'2px solid #2E75B6', borderRadius:'6px', padding:'16px 20px', margin:'16px 0' },
  infoBoxTitle: { fontWeight:'700', fontFamily:"'Courier New', monospace", fontSize:'0.88rem', color:'#1F3864', marginBottom:'8px' },
  infoBoxItem: { fontSize:'0.9rem', margin:'4px 0', paddingLeft:'12px', borderLeft:'2px solid #2E75B6' },
  table: { width:'100%', borderCollapse:'collapse', marginBottom:'20px', fontSize:'0.92rem' },
  th: { background:'#2E75B6', color:'#fff', padding:'10px 14px', textAlign:'left', fontWeight:'700', fontSize:'0.9rem' },
  tdE: { padding:'10px 14px', borderBottom:'1px solid #ccd9ea', verticalAlign:'top', background:'#f5f9ff' },
  tdO: { padding:'10px 14px', borderBottom:'1px solid #ccd9ea', verticalAlign:'top', background:'#fff' },
  tdL: { fontWeight:'600', color:'#1F3864', whiteSpace:'nowrap', width:'220px' },
  code: { fontFamily:"'Courier New', monospace", fontSize:'0.88rem', whiteSpace:'pre-wrap' },
  dWrap: { margin:'24px 0', background:'#f8fbff', border:'1px solid #ccd9ea', borderRadius:'8px', padding:'20px' },
  dTitle: { fontWeight:'700', fontSize:'0.95rem', color:'#1F3864', marginBottom:'12px', textAlign:'center', letterSpacing:'0.02em' },
  dCaption: { fontSize:'0.84rem', color:'#555', textAlign:'center', marginTop:'10px', fontStyle:'italic' },
};

function InfoBox({ title, items }) {
  return (
    <div style={S.infoBox}>
      <div style={S.infoBoxTitle}>{title}</div>
      {items.map((item, i) => <div key={i} style={S.infoBoxItem}>{item}</div>)}
    </div>
  );
}

function Table2({ rows }) {
  return (
    <table style={S.table}>
      <thead><tr>
        <th style={{ ...S.th, width:'220px' }}>Concept</th>
        <th style={S.th}>Formula / Notes</th>
      </tr></thead>
      <tbody>
        {rows.map(([label, content], i) => (
          <tr key={i}>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.tdL }}>{label}</td>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.code }}>{content}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

// ── Diagram 1: Types of Curves ───────────────────────────────────
function DiagramCurveTypes() {
  const W = 900, H = 320;
  const PW = (W - 5*10) / 4;

  // Curve 1: straight line (zero curvature)
  const l1x = 14, lw = PW;
  // Curve 2: circle (constant curvature)
  const c2x = 14 + PW + 10;
  const cx2 = c2x + PW/2, cy2 = 175, r2 = 88;
  // Curve 3: parabola (varying curvature)
  const p3x = 14 + 2*(PW+10);
  const pox = p3x + PW/2, poy = 230, psc = 28;
  const parPts = [];
  for (let x = -3.2; x <= 3.2; x += 0.1) parPts.push(`${pox+x*psc},${poy-x*x*psc*0.5}`);
  // Curve 4: general smooth curve (arbitrary curvature)
  const g4x = 14 + 3*(PW+10);
  const gox = g4x + 10, goy = 175;
  const generalPts = [];
  for (let t = 0; t <= 1; t += 0.01) {
    const x = gox + t*(PW-20);
    const y = goy + 60*Math.sin(t*Math.PI*2) - 20*Math.sin(t*Math.PI*5)*0.4;
    generalPts.push(`${x},${y}`);
  }

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Types of Curves — Straight Lines, Circles, Parabolas, and General Smooth Curves</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>

        {/* Panel 1: Straight line */}
        <rect x={14} y={10} width={PW} height={H-20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={14+PW/2} y={28} textAnchor="middle" fontSize="14" fill="#1F3864" fontWeight="700">Straight Line</text>
        <text x={14+PW/2} y={44} textAnchor="middle" fontSize="11" fill="#888">κ = 0 everywhere</text>
        <line x1={14+20} y1={175} x2={14+PW-20} y2={155} stroke="#2E75B6" strokeWidth="2.8"/>
        {/* tangent vectors all same direction */}
        {[0.2,0.4,0.6,0.8].map((t,i) => {
          const x = 14+20 + t*(PW-40);
          const y = 175 - t*20;
          return <g key={i}>
            <line x1={x} y1={y} x2={x+18} y2={y-3.6} stroke="#27ae60" strokeWidth="1.8"/>
            <polygon points={`${x+18},${y-3.6} ${x+10},${y-1} ${x+11},${y-7}`} fill="#27ae60"/>
          </g>;
        })}
        <rect x={20} y={240} width={PW-12} height={62} rx={3} fill="#EBF3FB" stroke="#2E75B6" strokeWidth="1"/>
        <text x={26} y={256} fontSize="12" fill="#1F3864" fontWeight="700">Curvature κ = 0</text>
        <text x={26} y={272} fontSize="11" fill="#555" fontFamily="'Courier New',monospace">Tangent direction constant</text>
        <text x={26} y={287} fontSize="11" fill="#555">Radius of curvature R = ∞</text>
        <text x={26} y={295} fontSize="10" fill="#888">y = mx + c</text>

        {/* Panel 2: Circle */}
        <rect x={c2x} y={10} width={PW} height={H-20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={cx2} y={28} textAnchor="middle" fontSize="14" fill="#1F3864" fontWeight="700">Circle</text>
        <text x={cx2} y={44} textAnchor="middle" fontSize="11" fill="#888">κ = 1/r (constant)</text>
        <circle cx={cx2} cy={cy2} r={r2} fill="none" stroke="#c0392b" strokeWidth="2.8"/>
        <circle cx={cx2} cy={cy2} r={3} fill="#1F3864"/>
        {/* radii to show constant curvature */}
        {[0, Math.PI/3, 2*Math.PI/3, Math.PI, 4*Math.PI/3, 5*Math.PI/3].map((a,i) => {
          const ex = cx2 + r2*Math.cos(a), ey = cy2 + r2*Math.sin(a);
          return <line key={i} x1={cx2} y1={cy2} x2={ex} y2={ey} stroke="#c0392b" strokeWidth="0.8" opacity="0.3"/>;
        })}
        {/* one radius label */}
        <line x1={cx2} y1={cy2} x2={cx2+r2*0.707} y2={cy2-r2*0.707} stroke="#9b59b6" strokeWidth="1.8"/>
        <text x={cx2+r2*0.38} y={cy2-r2*0.38-5} fontSize="12" fill="#9b59b6" fontWeight="700">R = r</text>
        <rect x={c2x+6} y={240} width={PW-12} height={62} rx={3} fill="#fde8e8" stroke="#c0392b" strokeWidth="1"/>
        <text x={c2x+12} y={256} fontSize="12" fill="#1F3864" fontWeight="700">Curvature κ = 1/r</text>
        <text x={c2x+12} y={272} fontSize="11" fill="#555" fontFamily="'Courier New',monospace">Same everywhere on circle</text>
        <text x={c2x+12} y={287} fontSize="11" fill="#555">Radius of curvature R = r</text>
        <text x={c2x+12} y={295} fontSize="10" fill="#888">x²+y²=r²</text>

        {/* Panel 3: Parabola */}
        <rect x={p3x} y={10} width={PW} height={H-20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={pox} y={28} textAnchor="middle" fontSize="14" fill="#1F3864" fontWeight="700">Parabola</text>
        <text x={pox} y={44} textAnchor="middle" fontSize="11" fill="#888">κ varies — max at vertex</text>
        <polyline points={parPts.join(" ")} fill="none" stroke="#27ae60" strokeWidth="2.8"/>
        {/* vertex */}
        <circle cx={pox} cy={poy} r={5} fill="#e07b00" stroke="#fff" strokeWidth="1.5"/>
        <text x={pox+8} y={poy+14} fontSize="11" fill="#e07b00" fontWeight="700">vertex: max κ</text>
        {/* osculating circle at vertex */}
        <circle cx={pox} cy={poy-45} r={45} fill="none" stroke="#e07b00" strokeWidth="1.4" strokeDasharray="5,3"/>
        <text x={pox+48} y={poy-62} fontSize="10" fill="#e07b00">osc. circle</text>
        <rect x={p3x+6} y={240} width={PW-12} height={62} rx={3} fill="#f0fff4" stroke="#27ae60" strokeWidth="1"/>
        <text x={p3x+12} y={256} fontSize="12" fill="#1F3864" fontWeight="700">Curvature varies</text>
        <text x={p3x+12} y={272} fontSize="11" fill="#555" fontFamily="'Courier New',monospace">Max κ at vertex (tightest)</text>
        <text x={p3x+12} y={287} fontSize="11" fill="#555">κ → 0 as curve straightens</text>
        <text x={p3x+12} y={295} fontSize="10" fill="#888">y = ax² at vertex: κ = 2|a|</text>

        {/* Panel 4: General curve */}
        <rect x={g4x} y={10} width={PW} height={H-20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={g4x+PW/2} y={28} textAnchor="middle" fontSize="14" fill="#1F3864" fontWeight="700">General Smooth Curve</text>
        <text x={g4x+PW/2} y={44} textAnchor="middle" fontSize="11" fill="#888">κ changes sign at inflection</text>
        <polyline points={generalPts.join(" ")} fill="none" stroke="#9b59b6" strokeWidth="2.8"/>
        {/* inflection point approx at t=0.5 */}
        {(()=>{
          const t=0.5, x=gox+t*(PW-20), y=goy+60*Math.sin(t*Math.PI*2)-20*Math.sin(t*Math.PI*5)*0.4;
          return <>
            <circle cx={x} cy={y} r={5} fill="#c0392b" stroke="#fff" strokeWidth="1.5"/>
            <text x={x+8} y={y-6} fontSize="11" fill="#c0392b" fontWeight="700">inflection</text>
            <text x={x+8} y={y+8} fontSize="10" fill="#c0392b">κ = 0</text>
          </>;
        })()}
        <rect x={g4x+6} y={240} width={PW-12} height={62} rx={3} fill="#f5d0ff" stroke="#9b59b6" strokeWidth="1"/>
        <text x={g4x+12} y={256} fontSize="12" fill="#1F3864" fontWeight="700">Variable curvature</text>
        <text x={g4x+12} y={272} fontSize="11" fill="#555" fontFamily="'Courier New',monospace">κ=0 at inflection points</text>
        <text x={g4x+12} y={287} fontSize="11" fill="#555">κ &gt; 0 concave up, κ &lt; 0 down</text>
        <text x={g4x+12} y={295} fontSize="10" fill="#888">sign of κ = sign of y''</text>
      </svg>
      <div style={S.dCaption}>Curvature κ measures how rapidly a curve changes direction. A straight line has κ=0; a circle has constant κ=1/r. For most curves curvature varies along the path — it is largest where the curve bends most tightly and zero at inflection points where concavity changes.</div>
    </div>
  );
}

// ── Diagram 2: Curvature Formula & Osculating Circle ─────────────
function DiagramCurvatureFormula() {
  const W = 900, H = 340;

  // Panel 1: curvature formula visualised on a curve
  const p1w = 420;
  const ox = 30, oy = 200, sc = 55;
  // y = sin(x) from -2 to 3.5
  const sinPts = [];
  for (let x = -2.2; x <= 3.5; x += 0.05) sinPts.push(`${ox + x*sc}, ${oy - Math.sin(x)*sc*0.9}`);
  // point P at x=0.8
  const px = 0.8, py = Math.sin(px);
  const Px = ox + px*sc, Py = oy - py*sc*0.9;
  // tangent direction
  const dydx = Math.cos(px);
  const tLen = 55;
  const tAngle = Math.atan(dydx * -0.9); // SVG y-flip
  const Tx = Math.cos(tAngle), Ty = Math.sin(tAngle);
  // normal direction (perpendicular to tangent)
  const Nx = -Ty, Ny = Tx;
  // curvature: κ = |y''| / (1+y'²)^(3/2) at x=0.8
  const ypp = -Math.sin(px);
  const yp = dydx;
  const kappa = Math.abs(ypp) / Math.pow(1 + yp*yp, 1.5);
  const R = 1/kappa;
  // centre of osculating circle
  const Rscaled = R * sc * 0.9;
  const ocx = Px + Nx * Rscaled * Math.sign(ypp);
  const ocy = Py + Ny * Rscaled * Math.sign(ypp);

  // Panel 2: signed curvature and concavity
  const p2x = 480;
  const p2ox = p2x + 30, p2oy = 180, p2sc = 48;
  const cosPts = [];
  for (let x = -2.8; x <= 2.8; x += 0.05) cosPts.push(`${p2ox + x*p2sc}, ${p2oy - Math.cos(x)*p2sc*0.85}`);
  // inflection at x = π/2
  const infX = p2ox + (Math.PI/2)*p2sc;
  const infY = p2oy - Math.cos(Math.PI/2)*p2sc*0.85;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Curvature Formula — Osculating Circle, Signed Curvature, and Concavity</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>

        {/* Panel 1: curvature & osculating circle */}
        <rect x={10} y={10} width={p1w} height={H-20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={10+p1w/2} y={28} textAnchor="middle" fontSize="15" fill="#1F3864" fontWeight="700">Osculating Circle at a Point</text>

        {/* axes */}
        <line x1={ox-20} y1={oy} x2={ox+3.8*sc} y2={oy} stroke="#ddd" strokeWidth="1"/>
        <line x1={ox} y1={oy+60} x2={ox} y2={oy-sc*1.1} stroke="#ddd" strokeWidth="1"/>

        {/* curve */}
        <polyline points={sinPts.join(" ")} fill="none" stroke="#2E75B6" strokeWidth="2.5"/>

        {/* osculating circle */}
        <circle cx={ocx} cy={ocy} r={Rscaled} fill="none" stroke="#e07b00" strokeWidth="1.8" strokeDasharray="6,3"/>

        {/* radius line to P */}
        <line x1={ocx} y1={ocy} x2={Px} y2={Py} stroke="#e07b00" strokeWidth="1.6"/>
        <text x={(ocx+Px)/2+8} y={(ocy+Py)/2} fontSize="12" fill="#e07b00" fontWeight="700">R=1/κ</text>

        {/* centre of osc circle */}
        <circle cx={ocx} cy={ocy} r={4} fill="#e07b00"/>
        <text x={ocx+6} y={ocy+4} fontSize="11" fill="#e07b00" fontWeight="700">centre of curvature</text>

        {/* tangent at P */}
        <line x1={Px - Tx*tLen} y1={Py - Ty*tLen} x2={Px + Tx*tLen} y2={Py + Ty*tLen} stroke="#27ae60" strokeWidth="2"/>
        <polygon points={`${Px+Tx*tLen},${Py+Ty*tLen} ${Px+Tx*(tLen-10)-Ty*5},${Py+Ty*(tLen-10)+Tx*5} ${Px+Tx*(tLen-10)+Ty*5},${Py+Ty*(tLen-10)-Tx*5}`} fill="#27ae60"/>
        <text x={Px+Tx*tLen+6} y={Py+Ty*tLen+4} fontSize="11" fill="#27ae60" fontWeight="700">tangent</text>

        {/* normal at P */}
        <line x1={Px} y1={Py} x2={Px + Nx*40*Math.sign(ypp)} y2={Py + Ny*40*Math.sign(ypp)} stroke="#c0392b" strokeWidth="1.8" strokeDasharray="4,3"/>
        <text x={Px + Nx*44*Math.sign(ypp)} y={Py + Ny*44*Math.sign(ypp)} fontSize="11" fill="#c0392b" fontWeight="700">normal</text>

        {/* point P */}
        <circle cx={Px} cy={Py} r={6} fill="#2E75B6" stroke="#fff" strokeWidth="2"/>
        <text x={Px+10} y={Py-8} fontSize="12" fill="#2E75B6" fontWeight="700">P</text>

        {/* formula boxes */}
        <rect x={18} y={258} width={p1w-26} height={62} rx={3} fill="#EBF3FB" stroke="#2E75B6" strokeWidth="1"/>
        <text x={24} y={274} fontSize="13" fill="#1F3864" fontWeight="700">Curvature formula  κ = |y''| / (1+y'²)^(3/2)</text>
        <text x={24} y={291} fontSize="12" fill="#2E75B6" fontFamily="'Courier New',monospace">Radius of curvature  R = 1/κ = (1+y'²)^(3/2) / |y''|</text>
        <text x={24} y={307} fontSize="11" fill="#555">Parametric:  κ = |x'y''−y'x''| / (x'²+y'²)^(3/2)</text>

        {/* Panel 2: signed curvature / concavity */}
        <rect x={p2x} y={10} width={W-p2x-10} height={H-20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={p2x+(W-p2x-10)/2} y={28} textAnchor="middle" fontSize="15" fill="#1F3864" fontWeight="700">Signed Curvature &amp; Concavity</text>

        <line x1={p2x+10} y1={p2oy} x2={W-18} y2={p2oy} stroke="#ddd" strokeWidth="1"/>
        <line x1={p2ox} y1={p2oy+60} x2={p2ox} y2={p2oy-sc*1.1} stroke="#ddd" strokeWidth="1"/>

        <polyline points={cosPts.join(" ")} fill="none" stroke="#9b59b6" strokeWidth="2.5"/>

        {/* label concave up region */}
        <rect x={p2x+14} y={p2oy-sc*0.55} width={80} height={28} rx={3} fill="#d0f0d8" fillOpacity="0.8"/>
        <text x={p2x+20} y={p2oy-sc*0.55+12} fontSize="11" fill="#27ae60" fontWeight="700">concave up</text>
        <text x={p2x+20} y={p2oy-sc*0.55+24} fontSize="10" fill="#27ae60">κ &gt; 0, y'' &gt; 0</text>

        {/* label concave down region */}
        <rect x={p2x+14} y={p2oy+20} width={85} height={28} rx={3} fill="#fde8e8" fillOpacity="0.8"/>
        <text x={p2x+20} y={p2oy+32} fontSize="11" fill="#c0392b" fontWeight="700">concave down</text>
        <text x={p2x+20} y={p2oy+44} fontSize="10" fill="#c0392b">κ &lt; 0, y'' &lt; 0</text>

        {/* inflection points */}
        {[-Math.PI/2, Math.PI/2].map((xi, i) => {
          const ix = p2ox + xi*p2sc;
          const iy = p2oy - Math.cos(xi)*p2sc*0.85;
          return <g key={i}>
            <circle cx={ix} cy={iy} r={5} fill="#e07b00" stroke="#fff" strokeWidth="1.5"/>
            <line x1={ix} y1={iy-18} x2={ix} y2={iy+18} stroke="#e07b00" strokeWidth="1.2" strokeDasharray="3,2"/>
          </g>;
        })}
        <text x={p2ox + (-Math.PI/2)*p2sc - 8} y={p2oy - 70} fontSize="11" fill="#e07b00" fontWeight="700" textAnchor="middle">inflection</text>
        <text x={p2ox + (-Math.PI/2)*p2sc - 8} y={p2oy - 58} fontSize="10" fill="#e07b00" textAnchor="middle">κ = 0</text>

        {/* formula boxes */}
        <rect x={p2x+8} y={258} width={W-p2x-22} height={62} rx={3} fill="#EBF3FB" stroke="#9b59b6" strokeWidth="1"/>
        <text x={p2x+14} y={274} fontSize="12" fill="#1F3864" fontWeight="700">Signed curvature κ = y'' / (1+y'²)^(3/2)</text>
        <text x={p2x+14} y={291} fontSize="11" fill="#555">κ &gt; 0: concave up (bends toward +y)</text>
        <text x={p2x+14} y={307} fontSize="11" fill="#555">κ &lt; 0: concave down (bends toward −y)</text>
        <text x={p2x+14} y={322} fontSize="11" fill="#555">κ = 0: inflection — concavity changes sign</text>
      </svg>
      <div style={S.dCaption}>The osculating circle at a point P is the circle that best fits the curve there — it has the same tangent, same curvature, and lies on the concave side. Its radius R=1/κ is the radius of curvature. Signed curvature tracks both magnitude and the direction of bending.</div>
    </div>
  );
}

// ── Diagram 3: Arc Length ────────────────────────────────────────
function DiagramArcLength() {
  const W = 900, H = 320;

  // Left panel: arc length integral visualised
  const lw = 430;
  const ox = 40, oy = 200, sc = 52;
  // y = x^2/4 from 0 to 4
  const curvePts = [];
  for (let x = -0.3; x <= 4.3; x += 0.05) curvePts.push(`${ox+x*sc},${oy - (x*x/4)*sc*0.85}`);

  // Draw several ds segments
  const dsSegs = [];
  for (let i = 0; i < 5; i++) {
    const x1 = 0.5 + i*0.7, x2 = x1 + 0.7;
    const y1v = x1*x1/4, y2v = x2*x2/4;
    dsSegs.push({
      x1: ox+x1*sc, y1: oy-y1v*sc*0.85,
      x2: ox+x2*sc, y2: oy-y2v*sc*0.85,
    });
  }

  // Right panel: 3 forms of arc length
  const rw = W - lw - 30;
  const rx = lw + 20;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Arc Length — The Integral of ds Along a Curve</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>

        {/* Left panel */}
        <rect x={10} y={10} width={lw} height={H-20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={10+lw/2} y={28} textAnchor="middle" fontSize="15" fill="#1F3864" fontWeight="700">Arc Length as a Limit of Chord Sums</text>

        <line x1={ox-10} y1={oy} x2={ox+4.5*sc} y2={oy} stroke="#1F3864" strokeWidth="1.2"/>
        <line x1={ox} y1={oy+30} x2={ox} y2={oy-sc*1.2} stroke="#1F3864" strokeWidth="1.2"/>
        <polygon points={`${ox+4.5*sc},${oy} ${ox+4.5*sc-8},${oy-4} ${ox+4.5*sc-8},${oy+4}`} fill="#1F3864"/>
        <polygon points={`${ox},${oy-sc*1.2} ${ox-4},${oy-sc*1.2+8} ${ox+4},${oy-sc*1.2+8}`} fill="#1F3864"/>
        <text x={ox+4.5*sc+6} y={oy+4} fontSize="13" fill="#1F3864">x</text>
        <text x={ox+4} y={oy-sc*1.2-4} fontSize="13" fill="#1F3864">y</text>

        {/* The curve */}
        <polyline points={curvePts.join(" ")} fill="none" stroke="#2E75B6" strokeWidth="2.5"/>

        {/* chord segments ds */}
        {dsSegs.map((seg, i) => (
          <g key={i}>
            <line x1={seg.x1} y1={seg.y1} x2={seg.x2} y2={seg.y2} stroke="#c0392b" strokeWidth="2.2"/>
            <circle cx={seg.x1} cy={seg.y1} r={3} fill="#c0392b"/>
          </g>
        ))}
        <circle cx={dsSegs[4].x2} cy={dsSegs[4].y2} r={3} fill="#c0392b"/>

        {/* ds label with right triangle */}
        {(()=>{
          const seg = dsSegs[2];
          const mx = (seg.x1+seg.x2)/2, my = (seg.y1+seg.y2)/2 + 8;
          return <>
            <line x1={seg.x1} y1={seg.y2} x2={seg.x2} y2={seg.y2} stroke="#27ae60" strokeWidth="1.2" strokeDasharray="4,2"/>
            <line x1={seg.x1} y1={seg.y1} x2={seg.x1} y2={seg.y2} stroke="#e07b00" strokeWidth="1.2" strokeDasharray="4,2"/>
            <text x={(seg.x1+seg.x2)/2} y={seg.y2+14} textAnchor="middle" fontSize="11" fill="#27ae60" fontWeight="700">dx</text>
            <text x={seg.x1-16} y={(seg.y1+seg.y2)/2} fontSize="11" fill="#e07b00" fontWeight="700">dy</text>
            <text x={mx+10} y={my-18} fontSize="12" fill="#c0392b" fontWeight="700">ds</text>
            <text x={mx+8} y={my-6} fontSize="10" fill="#c0392b">= √(dx²+dy²)</text>
          </>;
        })()}

        {/* integration limits */}
        {(()=>{
          const xa = ox+0.5*sc, ya = oy-0.5*0.5/4*sc*0.85;
          const xb = ox+4.0*sc, yb = oy-4.0*4.0/4*sc*0.85;
          return <>
            <line x1={xa} y1={oy} x2={xa} y2={ya} stroke="#9b59b6" strokeWidth="1.2" strokeDasharray="3,3"/>
            <line x1={xb} y1={oy} x2={xb} y2={yb} stroke="#9b59b6" strokeWidth="1.2" strokeDasharray="3,3"/>
            <text x={xa} y={oy+16} textAnchor="middle" fontSize="12" fill="#9b59b6" fontWeight="700">a</text>
            <text x={xb} y={oy+16} textAnchor="middle" fontSize="12" fill="#9b59b6" fontWeight="700">b</text>
          </>;
        })()}

        {/* formula box */}
        <rect x={16} y={248} width={lw-22} height={54} rx={3} fill="#EBF3FB" stroke="#2E75B6" strokeWidth="1"/>
        <text x={22} y={265} fontSize="13" fill="#1F3864" fontWeight="700">Arc length:  L = ∫ ds  =  ∫ₐᵇ √(1 + (dy/dx)²) dx</text>
        <text x={22} y={283} fontSize="12" fill="#2E75B6" fontFamily="'Courier New',monospace">ds = √(dx² + dy²) = √(1+y'²) dx</text>
        <text x={22} y={296} fontSize="11" fill="#555">As partition → 0, chord sum → exact arc length</text>

        {/* Right panel */}
        <rect x={rx} y={10} width={rw} height={H-20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={rx+rw/2} y={28} textAnchor="middle" fontSize="15" fill="#1F3864" fontWeight="700">Three Forms of Arc Length</text>

        {[
          {y:44,  bg:"#EBF3FB",  bc:"#2E75B6",  title:"Cartesian  y = f(x)",
           lines:["L = ∫ₐᵇ √(1 + (dy/dx)²) dx","Use when y is given as a function of x"]},
          {y:128, bg:"#f0fff4",  bc:"#27ae60",  title:"Parametric  (x(t), y(t))",
           lines:["L = ∫ₜ₁ᵗ² √((dx/dt)² + (dy/dt)²) dt","x' and y' are derivatives w.r.t. parameter t"]},
          {y:212, bg:"#fff7ee",  bc:"#e07b00",  title:"Polar  r = f(θ)",
           lines:["L = ∫ₐᵝ √(r² + (dr/dθ)²) dθ","r = radius as function of angle θ"]},
        ].map(({y,bg,bc,title,lines}) => (
          <g key={title}>
            <rect x={rx+8} y={y} width={rw-16} height={76} rx={4} fill={bg} stroke={bc} strokeWidth="1.2"/>
            <text x={rx+14} y={y+16} fontSize="13" fill="#1F3864" fontWeight="700">{title}</text>
            {lines.map((ln,i) => <text key={i} x={rx+14} y={y+34+i*18} fontSize="11" fill={i===0?"#1F3864":"#555"} fontFamily={i===0?"'Courier New',monospace":"'Georgia',serif"} fontWeight={i===0?"700":"400"}>{ln}</text>)}
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>Arc length is the total distance along a curve. The element ds=√(dx²+dy²) comes from the Pythagorean theorem applied to infinitesimal steps. The three forms handle Cartesian, parametric, and polar representations — all reduce to integrating ds over the appropriate variable.</div>
    </div>
  );
}

// ── Diagram 4: Parametric Curves ─────────────────────────────────
function DiagramParametric() {
  const W = 900, H = 330;
  const PW = (W - 4*10) / 3;

  // Panel 1: general parametric curve with tangent
  const p1cx = 14 + PW/2, p1cy = 170, p1sc = 46;
  const paramPts = [];
  for (let t = 0; t <= 2*Math.PI; t += 0.04) {
    paramPts.push(`${p1cx + (2*Math.cos(t)+0.5*Math.cos(2*t))*p1sc*0.55}, ${p1cy - (2*Math.sin(t)-0.5*Math.sin(2*t))*p1sc*0.55}`);
  }
  // tangent at t = Math.PI/3
  const tval = Math.PI/3;
  const ptx = p1cx + (2*Math.cos(tval)+0.5*Math.cos(2*tval))*p1sc*0.55;
  const pty = p1cy - (2*Math.sin(tval)-0.5*Math.sin(2*tval))*p1sc*0.55;
  const dxdt = -2*Math.sin(tval)-Math.sin(2*tval);
  const dydt =  2*Math.cos(tval)-Math.cos(2*tval);
  const tanLen = 40;
  const tanMag = Math.sqrt(dxdt*dxdt+dydt*dydt);
  const dtx = dxdt/tanMag*tanLen, dty = -dydt/tanMag*tanLen;

  // Panel 2: lissajous
  const p2ox = 14+PW+10+PW/2, p2oy = 170;
  const lissPts = [];
  for (let t = 0; t <= 2*Math.PI; t += 0.02) {
    lissPts.push(`${p2ox + Math.sin(2*t+0.5)*90}, ${p2oy - Math.sin(3*t)*70}`);
  }

  // Panel 3: cycloid
  const p3ox = 14+2*(PW+10), p3oy = 220, p3r = 38;
  const cycloidPts = [];
  for (let t = 0; t <= 2*Math.PI; t += 0.04) {
    cycloidPts.push(`${p3ox + p3r*(t - Math.sin(t))}, ${p3oy - p3r*(1 - Math.cos(t))}`);
  }
  // rolling circle position at t = Math.PI
  const ct = Math.PI;
  const circX = p3ox + p3r*(ct - Math.sin(ct));
  const circY = p3oy - p3r*(1 - Math.cos(ct));

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Parametric Curves — Tangents, Lissajous Figures, and the Cycloid</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>

        {/* Panel 1 */}
        <rect x={14} y={10} width={PW} height={H-20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={14+PW/2} y={28} textAnchor="middle" fontSize="14" fill="#1F3864" fontWeight="700">Parametric Curve</text>
        <text x={14+PW/2} y={44} textAnchor="middle" fontSize="11" fill="#888">x=x(t), y=y(t)</text>
        <polyline points={paramPts.join(" ")} fill="none" stroke="#2E75B6" strokeWidth="2.5"/>
        {/* tangent */}
        <line x1={ptx-dtx} y1={pty-dty} x2={ptx+dtx} y2={pty+dty} stroke="#27ae60" strokeWidth="2"/>
        <polygon points={`${ptx+dtx},${pty+dty} ${ptx+dtx-8*dtx/tanLen-5*dty/tanLen},${pty+dty-8*dty/tanLen+5*dtx/tanLen} ${ptx+dtx-8*dtx/tanLen+5*dty/tanLen},${pty+dty-8*dty/tanLen-5*dtx/tanLen}`} fill="#27ae60"/>
        <circle cx={ptx} cy={pty} r={5} fill="#e07b00" stroke="#fff" strokeWidth="1.5"/>
        <text x={ptx+8} y={pty-8} fontSize="11" fill="#e07b00" fontWeight="700">P(t)</text>
        <text x={ptx+dtx+6} y={pty+dty+4} fontSize="11" fill="#27ae60" fontWeight="700">dy/dx = (dy/dt)/(dx/dt)</text>
        <rect x={20} y={252} width={PW-12} height={60} rx={3} fill="#EBF3FB" stroke="#2E75B6" strokeWidth="1"/>
        <text x={26} y={268} fontSize="12" fill="#1F3864" fontWeight="700">Tangent slope:</text>
        <text x={26} y={284} fontSize="12" fill="#2E75B6" fontFamily="'Courier New',monospace">dy/dx = (dy/dt) / (dx/dt)</text>
        <text x={26} y={300} fontSize="11" fill="#555">2nd deriv: d²y/dx² = (d/dt[dy/dx]) / (dx/dt)</text>

        {/* Panel 2: Lissajous */}
        <rect x={14+PW+10} y={10} width={PW} height={H-20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={p2ox} y={28} textAnchor="middle" fontSize="14" fill="#1F3864" fontWeight="700">Lissajous Figure</text>
        <text x={p2ox} y={44} textAnchor="middle" fontSize="11" fill="#888">x=sin(2t+φ), y=sin(3t)</text>
        <line x1={14+PW+18} y1={p2oy} x2={14+PW+10+PW-8} y2={p2oy} stroke="#eee" strokeWidth="1"/>
        <line x1={p2ox} y1={p2oy-90} x2={p2ox} y2={p2oy+90} stroke="#eee" strokeWidth="1"/>
        <polyline points={lissPts.join(" ")} fill="none" stroke="#9b59b6" strokeWidth="2.5"/>
        <rect x={14+PW+16} y={252} width={PW-12} height={60} rx={3} fill="#f5d0ff" stroke="#9b59b6" strokeWidth="1"/>
        <text x={14+PW+22} y={268} fontSize="12" fill="#1F3864" fontWeight="700">Frequency ratio determines shape</text>
        <text x={14+PW+22} y={284} fontSize="11" fill="#555">Integer ratios → closed curves</text>
        <text x={14+PW+22} y={300} fontSize="11" fill="#555">Used in: oscilloscopes, signal analysis</text>

        {/* Panel 3: Cycloid */}
        <rect x={14+2*(PW+10)} y={10} width={PW} height={H-20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={14+2*(PW+10)+PW/2} y={28} textAnchor="middle" fontSize="14" fill="#1F3864" fontWeight="700">Cycloid</text>
        <text x={14+2*(PW+10)+PW/2} y={44} textAnchor="middle" fontSize="11" fill="#888">x=r(t−sin t), y=r(1−cos t)</text>
        <line x1={14+2*(PW+10)+8} y1={p3oy} x2={14+2*(PW+10)+PW-8} y2={p3oy} stroke="#ddd" strokeWidth="1.5"/>
        <polyline points={cycloidPts.join(" ")} fill="none" stroke="#c0392b" strokeWidth="2.5"/>
        {/* rolling circle */}
        <circle cx={circX} cy={circY-p3r} r={p3r} fill="none" stroke="#e07b00" strokeWidth="1.4" strokeDasharray="4,3"/>
        <circle cx={circX} cy={circY-p3r} r={3} fill="#e07b00"/>
        <circle cx={circX} cy={circY} r={4} fill="#c0392b" stroke="#fff" strokeWidth="1.5"/>
        <line x1={circX} y1={circY-p3r} x2={circX} y2={circY} stroke="#e07b00" strokeWidth="1.2"/>
        {/* cusp labels */}
        <circle cx={p3ox} cy={p3oy} r={4} fill="#c0392b"/>
        <text x={p3ox} y={p3oy+16} textAnchor="middle" fontSize="10" fill="#c0392b" fontWeight="700">cusp</text>
        <rect x={14+2*(PW+10)+8} y={252} width={PW-16} height={60} rx={3} fill="#fde8e8" stroke="#c0392b" strokeWidth="1"/>
        <text x={14+2*(PW+10)+14} y={268} fontSize="12" fill="#1F3864" fontWeight="700">Path traced by point on rolling circle</text>
        <text x={14+2*(PW+10)+14} y={284} fontSize="11" fill="#555">Arc length (one arch) = 8r</text>
        <text x={14+2*(PW+10)+14} y={300} fontSize="11" fill="#555">Area under one arch = 3πr²</text>
      </svg>
      <div style={S.dCaption}>Parametric curves express x and y as separate functions of a parameter t, enabling self-intersecting, closed, and complex paths impossible to write as y=f(x). The tangent slope is (dy/dt)/(dx/dt). Lissajous figures arise from perpendicular oscillations; the cycloid is traced by a point on a rolling circle.</div>
    </div>
  );
}

// ── Diagram 5: Polar Curves ──────────────────────────────────────
function DiagramPolar() {
  const W = 900, H = 340;
  const PW = (W - 4*10) / 3;

  // Panel 1: cardioid r = 1 + cos θ
  const c1ox = 14 + PW/2, c1oy = 175, c1sc = 68;
  const cardioidPts = [];
  for (let t = 0; t <= 2*Math.PI; t += 0.03) {
    const r = 1 + Math.cos(t);
    cardioidPts.push(`${c1ox + r*Math.cos(t)*c1sc}, ${c1oy - r*Math.sin(t)*c1sc}`);
  }

  // Panel 2: rose r = cos(3θ)
  const r2ox = 14+PW+10+PW/2, r2oy = 175, r2sc = 100;
  const rosePts = [];
  for (let t = 0; t <= Math.PI; t += 0.02) {
    const r = Math.cos(3*t);
    rosePts.push(`${r2ox + r*Math.cos(t)*r2sc}, ${r2oy - r*Math.sin(t)*r2sc}`);
  }

  // Panel 3: Archimedean spiral r = θ/3
  const s3ox = 14+2*(PW+10)+PW/2, s3oy = 185, s3sc = 22;
  const spiralPts = [];
  for (let t = 0; t <= 4*Math.PI; t += 0.05) {
    const r = t/3;
    spiralPts.push(`${s3ox + r*Math.cos(t)*s3sc}, ${s3oy - r*Math.sin(t)*s3sc}`);
  }

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Polar Curves — Cardioid, Rose Curve, and Archimedean Spiral</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>

        {/* Panel 1: Cardioid */}
        <rect x={14} y={10} width={PW} height={H-20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={14+PW/2} y={28} textAnchor="middle" fontSize="14" fill="#1F3864" fontWeight="700">Cardioid</text>
        <text x={14+PW/2} y={44} textAnchor="middle" fontSize="11" fill="#888">r = 1 + cos θ</text>
        {/* polar grid */}
        {[0.5,1,1.5,2].map(r => <circle key={r} cx={c1ox} cy={c1oy} r={r*c1sc} fill="none" stroke="#eee" strokeWidth="1"/>)}
        {[0,Math.PI/4,Math.PI/2,3*Math.PI/4].map((a,i) => (
          <line key={i} x1={c1ox-2*c1sc*Math.cos(a)} y1={c1oy+2*c1sc*Math.sin(a)} x2={c1ox+2*c1sc*Math.cos(a)} y2={c1oy-2*c1sc*Math.sin(a)} stroke="#eee" strokeWidth="1"/>
        ))}
        <polyline points={cardioidPts.join(" ")} fill="#d0e8ff" fillOpacity="0.4" stroke="#2E75B6" strokeWidth="2.5"/>
        <circle cx={c1ox} cy={c1oy} r={3} fill="#1F3864"/>
        <text x={c1ox+4} y={c1oy+14} fontSize="11" fill="#1F3864">O</text>
        {/* cusp */}
        <circle cx={c1ox} cy={c1oy} r={4} fill="#c0392b"/>
        <text x={c1ox-28} y={c1oy+16} fontSize="10" fill="#c0392b" fontWeight="700">cusp</text>
        <rect x={20} y={262} width={PW-12} height={60} rx={3} fill="#EBF3FB" stroke="#2E75B6" strokeWidth="1"/>
        <text x={26} y={278} fontSize="12" fill="#1F3864" fontWeight="700">r = a(1 + cos θ)  or  r = a(1 + sin θ)</text>
        <text x={26} y={294} fontSize="11" fill="#555">Heart-shaped; cusp at origin</text>
        <text x={26} y={310} fontSize="11" fill="#555">Area = (3/2)πa²</text>

        {/* Panel 2: Rose */}
        <rect x={14+PW+10} y={10} width={PW} height={H-20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={r2ox} y={28} textAnchor="middle" fontSize="14" fill="#1F3864" fontWeight="700">Rose Curve</text>
        <text x={r2ox} y={44} textAnchor="middle" fontSize="11" fill="#888">r = cos(nθ)</text>
        {[0.5,1].map(r => <circle key={r} cx={r2ox} cy={r2oy} r={r*r2sc} fill="none" stroke="#eee" strokeWidth="1"/>)}
        {[0,Math.PI/3,2*Math.PI/3].map((a,i) => (
          <line key={i} x1={r2ox-1.1*r2sc*Math.cos(a)} y1={r2oy+1.1*r2sc*Math.sin(a)} x2={r2ox+1.1*r2sc*Math.cos(a)} y2={r2oy-1.1*r2sc*Math.sin(a)} stroke="#eee" strokeWidth="1"/>
        ))}
        {/* draw all 3 petals */}
        {[0,1,2].map(k => {
          const pts = [];
          const start = k*Math.PI/3 - Math.PI/6;
          for (let t = start; t <= start + Math.PI/3; t += 0.02) {
            const r = Math.max(0, Math.cos(3*t));
            pts.push(`${r2ox + r*Math.cos(t)*r2sc}, ${r2oy - r*Math.sin(t)*r2sc}`);
          }
          pts.push(`${r2ox},${r2oy}`);
          return <polygon key={k} points={pts.join(" ")} fill={["#d0e8ff","#d0f0d8","#fde8e8"][k]} fillOpacity="0.6" stroke={["#2E75B6","#27ae60","#c0392b"][k]} strokeWidth="2"/>;
        })}
        <circle cx={r2ox} cy={r2oy} r={3} fill="#1F3864"/>
        <rect x={14+PW+16} y={262} width={PW-12} height={60} rx={3} fill="#f0fff4" stroke="#27ae60" strokeWidth="1"/>
        <text x={14+PW+22} y={278} fontSize="12" fill="#1F3864" fontWeight="700">r = cos(nθ)  or  r = sin(nθ)</text>
        <text x={14+PW+22} y={294} fontSize="11" fill="#555">n odd → n petals;  n even → 2n petals</text>
        <text x={14+PW+22} y={310} fontSize="11" fill="#555">Each petal area = π/(4n)</text>

        {/* Panel 3: Spiral */}
        <rect x={14+2*(PW+10)} y={10} width={PW} height={H-20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={14+2*(PW+10)+PW/2} y={28} textAnchor="middle" fontSize="14" fill="#1F3864" fontWeight="700">Archimedean Spiral</text>
        <text x={14+2*(PW+10)+PW/2} y={44} textAnchor="middle" fontSize="11" fill="#888">r = aθ</text>
        {[1,2,3].map(r => <circle key={r} cx={s3ox} cy={s3oy} r={r*s3sc} fill="none" stroke="#eee" strokeWidth="1"/>)}
        {[0,Math.PI/4,Math.PI/2,3*Math.PI/4].map((a,i) => (
          <line key={i} x1={s3ox - 3.2*s3sc*Math.cos(a)} y1={s3oy+3.2*s3sc*Math.sin(a)} x2={s3ox + 3.2*s3sc*Math.cos(a)} y2={s3oy-3.2*s3sc*Math.sin(a)} stroke="#eee" strokeWidth="1"/>
        ))}
        <polyline points={spiralPts.join(" ")} fill="none" stroke="#e07b00" strokeWidth="2.5"/>
        <circle cx={s3ox} cy={s3oy} r={3} fill="#1F3864"/>
        {/* constant spacing arrows */}
        {(()=>{
          const t1 = Math.PI, t2 = 3*Math.PI;
          const r1 = t1/3, r2 = t2/3;
          const x1 = s3ox + r1*Math.cos(Math.PI)*s3sc, y1 = s3oy - r1*Math.sin(Math.PI)*s3sc;
          const x2 = s3ox + r2*Math.cos(3*Math.PI)*s3sc, y2 = s3oy - r2*Math.sin(3*Math.PI)*s3sc;
          return <>
            <circle cx={x1} cy={y1} r={3} fill="#e07b00"/>
            <circle cx={x2} cy={y2} r={3} fill="#e07b00"/>
            <line x1={x1} y1={y1} x2={x2} y2={y2} stroke="#e07b00" strokeWidth="1.2" strokeDasharray="3,2"/>
            <text x={(x1+x2)/2} y={(y1+y2)/2-6} textAnchor="middle" fontSize="10" fill="#e07b00" fontWeight="700">constant gap 2πa</text>
          </>;
        })()}
        <rect x={14+2*(PW+10)+8} y={262} width={PW-16} height={60} rx={3} fill="#fff7ee" stroke="#e07b00" strokeWidth="1"/>
        <text x={14+2*(PW+10)+14} y={278} fontSize="12" fill="#1F3864" fontWeight="700">r = aθ  (Archimedean)</text>
        <text x={14+2*(PW+10)+14} y={294} fontSize="11" fill="#555">Constant spacing 2πa between arms</text>
        <text x={14+2*(PW+10)+14} y={310} fontSize="11" fill="#555">Other: logarithmic r = ae^(bθ)</text>
      </svg>
      <div style={S.dCaption}>Polar curves use radius r as a function of angle θ. The cardioid has a cusp at the origin. Rose curves produce petal patterns with n or 2n petals depending on n. The Archimedean spiral has equal radial spacing; the logarithmic spiral appears throughout nature (nautilus shells, galaxies).</div>
    </div>
  );
}

// ── Diagram 6: Evolutes and Involutes ────────────────────────────
function DiagramEvoluteInvolute() {
  const W = 900, H = 310;
  const LW = 440;

  // Evolute of ellipse: a=160, b=90
  const ea = 160, eb = 90;
  const eox = 14 + LW/2, eoy = 165;
  const ellipsePts = [];
  const evolutePts = [];
  const radiiLines = [];
  for (let t = 0; t <= 2*Math.PI; t += 0.04) {
    const ex = eox + ea*Math.cos(t), ey = eoy - eb*Math.sin(t);
    ellipsePts.push(`${ex},${ey}`);
    // evolute of ellipse: parametric
    const evx = eox + (ea*ea - eb*eb)/ea * Math.cos(t)*Math.cos(t)*Math.cos(t);
    const evy = eoy + (eb*eb - ea*ea)/eb * Math.sin(t)*Math.sin(t)*Math.sin(t);
    evolutePts.push(`${evx},${evy}`);
  }
  // a few radius of curvature lines
  for (let k = 0; k < 6; k++) {
    const t = k * Math.PI / 3;
    const ex = eox + ea*Math.cos(t), ey = eoy - eb*Math.sin(t);
    const evx = eox + (ea*ea - eb*eb)/ea * Math.pow(Math.cos(t),3);
    const evy = eoy + (eb*eb - ea*ea)/eb * Math.pow(Math.sin(t),3);
    radiiLines.push({x1:ex, y1:ey, x2:evx, y2:evy});
  }

  // Right: involute of circle
  const icox = 14 + LW + 20 + (W - LW - 34)/2, icoy = 165, icr = 55;
  const circleInPts = [];
  const involutePts = [];
  for (let t = 0; t <= 4*Math.PI; t += 0.04) {
    circleInPts.push(`${icox + icr*Math.cos(t)},${icoy - icr*Math.sin(t)}`);
    const ix = icox + icr*(Math.cos(t) + t*Math.sin(t));
    const iy = icoy - icr*(Math.sin(t) - t*Math.cos(t));
    involutePts.push(`${ix},${iy}`);
  }
  // string line at t=2
  const ts = 2.2;
  const sx1 = icox + icr*Math.cos(ts), sy1 = icoy - icr*Math.sin(ts);
  const sx2 = icox + icr*(Math.cos(ts)+ts*Math.sin(ts)), sy2 = icoy - icr*(Math.sin(ts)-ts*Math.cos(ts));

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Evolute and Involute — The Locus of Centres of Curvature</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>

        {/* Left: evolute of ellipse */}
        <rect x={10} y={10} width={LW} height={H-20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={10+LW/2} y={28} textAnchor="middle" fontSize="15" fill="#1F3864" fontWeight="700">Evolute of an Ellipse</text>
        <text x={10+LW/2} y={44} textAnchor="middle" fontSize="11" fill="#888">Locus of all centres of curvature</text>
        {/* radii of curvature */}
        {radiiLines.map((l,i) => <line key={i} x1={l.x1} y1={l.y1} x2={l.x2} y2={l.y2} stroke="#e07b00" strokeWidth="1" opacity="0.4"/>)}
        {/* ellipse */}
        <polyline points={ellipsePts.join(" ")} fill="none" stroke="#2E75B6" strokeWidth="2.2"/>
        {/* evolute */}
        <polyline points={evolutePts.join(" ")} fill="none" stroke="#c0392b" strokeWidth="2.2"/>
        {/* labels */}
        <text x={eox+ea+4} y={eoy+4} fontSize="12" fill="#2E75B6" fontWeight="700">ellipse</text>
        <text x={eox+(ea*ea-eb*eb)/ea+6} y={eoy+12} fontSize="12" fill="#c0392b" fontWeight="700">evolute</text>
        {/* one radius annotated */}
        {(()=>{
          const t = Math.PI/5;
          const ex = eox + ea*Math.cos(t), ey = eoy - eb*Math.sin(t);
          const evx = eox + (ea*ea-eb*eb)/ea*Math.pow(Math.cos(t),3);
          const evy = eoy + (eb*eb-ea*ea)/eb*Math.pow(Math.sin(t),3);
          return <>
            <line x1={ex} y1={ey} x2={evx} y2={evy} stroke="#e07b00" strokeWidth="1.8"/>
            <circle cx={evx} cy={evy} r={4} fill="#e07b00"/>
            <text x={(ex+evx)/2+6} y={(ey+evy)/2-4} fontSize="11" fill="#e07b00" fontWeight="700">R=1/κ</text>
          </>;
        })()}
        <rect x={16} y={248} width={LW-22} height={44} rx={3} fill="#EBF3FB" stroke="#2E75B6" strokeWidth="1"/>
        <text x={22} y={264} fontSize="12" fill="#1F3864" fontWeight="700">Evolute = locus of centres of curvature of the original curve</text>
        <text x={22} y={281} fontSize="11" fill="#555">Normals to the original curve are tangents to the evolute</text>

        {/* Right: involute of circle */}
        <rect x={14+LW+10} y={10} width={W-LW-34} height={H-20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={icox} y={28} textAnchor="middle" fontSize="15" fill="#1F3864" fontWeight="700">Involute of a Circle</text>
        <text x={icox} y={44} textAnchor="middle" fontSize="11" fill="#888">Path of string end unwinding from circle</text>
        {/* base circle */}
        <circle cx={icox} cy={icoy} r={icr} fill="#d0e8ff" fillOpacity="0.3" stroke="#2E75B6" strokeWidth="1.8"/>
        <circle cx={icox} cy={icoy} r={3} fill="#1F3864"/>
        {/* involute */}
        <polyline points={involutePts.join(" ")} fill="none" stroke="#27ae60" strokeWidth="2.2"/>
        {/* string */}
        <line x1={sx1} y1={sy1} x2={sx2} y2={sy2} stroke="#e07b00" strokeWidth="1.8"/>
        <circle cx={sx2} cy={sy2} r={4} fill="#e07b00" stroke="#fff" strokeWidth="1.5"/>
        <text x={sx2+6} y={sy2-6} fontSize="11" fill="#e07b00" fontWeight="700">P</text>
        <text x={icox+icr+6} y={icoy+4} fontSize="11" fill="#2E75B6" fontWeight="700">base circle</text>
        <text x={icox-80} y={icoy-90} fontSize="11" fill="#27ae60" fontWeight="700">involute</text>
        <rect x={14+LW+16} y={248} width={W-LW-40} height={44} rx={3} fill="#f0fff4" stroke="#27ae60" strokeWidth="1"/>
        <text x={14+LW+22} y={264} fontSize="12" fill="#1F3864" fontWeight="700">Involute = curve traced by end of taut string</text>
        <text x={14+LW+22} y={281} fontSize="11" fill="#555">Application: gear tooth profiles (involute gears)</text>
      </svg>
      <div style={S.dCaption}>The evolute of a curve is the locus of its centres of curvature. Every normal to the original curve is tangent to the evolute, and the evolute is itself the envelope of the normals. The involute is the reverse process — unwinding a string from the evolute regenerates the original curve.</div>
    </div>
  );
}

// ── Main ─────────────────────────────────────────────────────────
export default function CurvesCurvature() {
  return (
    <div style={S.wrapper}>
      <h1 style={S.h1}>Curves and Curvature</h1>
      <p style={S.p}>Curvature quantifies how rapidly a curve deviates from a straight line. It underpins the differential geometry of plane curves, the physics of motion along curved paths, the design of roads and railways, the behaviour of elastic beams, and the study of surfaces in higher dimensions.</p>

      <InfoBox title="The Central Idea: Curvature κ = rate of turning per unit arc length" items={[
        "κ = dφ/ds  where φ is the tangent angle and s is arc length",
        "Straight line: κ = 0 everywhere — tangent direction never changes",
        "Circle of radius r: κ = 1/r everywhere — constant turning rate",
        "General curve: κ varies — largest where curve bends most sharply",
        "Radius of curvature R = 1/κ — radius of the best-fitting circle at each point",
        "Inflection point: κ = 0, curve changes from concave up to concave down",
      ]}/>

      <h2 style={S.h2}>Types of Curves</h2>
      <DiagramCurveTypes/>
      <Table2 rows={[
        ["Plane curve","Any continuous path in the xy-plane\nCan be expressed as y=f(x), parametrically, or in polar form"],
        ["Smooth curve","Has a continuous, non-zero tangent vector everywhere\nNo corners, cusps, or self-intersections (locally)"],
        ["Simple curve","Does not cross itself (except possibly at endpoints)\nClosed simple curve encloses a region (Jordan curve theorem)"],
        ["Curvature κ","κ = |dT/ds| where T is the unit tangent vector\nMeasures how fast direction changes per unit arc length"],
        ["Concave up / down","y'' > 0: concave up (holds water)\ny'' < 0: concave down (spills water)"],
        ["Inflection point","y'' = 0 and changes sign; κ = 0 at that point\nCurve crosses its own tangent line"],
      ]}/>

      <h2 style={S.h2}>Curvature Formula and Osculating Circle</h2>
      <DiagramCurvatureFormula/>
      <Table2 rows={[
        ["Curvature (Cartesian)","κ = |y''| / (1 + y'²)^(3/2)\nFor y = f(x); derived from the arc-length parametrisation"],
        ["Signed curvature","κ = y'' / (1 + y'²)^(3/2)\nPositive = concave up, negative = concave down"],
        ["Curvature (parametric)","κ = |x'y'' − y'x''| / (x'² + y'²)^(3/2)\nx', y' are derivatives w.r.t. parameter t"],
        ["Curvature (polar)","κ = |r²+2(r')²−rr''| / (r²+(r')²)^(3/2)\nr' = dr/dθ, r'' = d²r/dθ²"],
        ["Radius of curvature","R = 1/κ = (1+y'²)^(3/2) / |y''|\nRadius of the osculating circle"],
        ["Osculating circle","Circle tangent to curve at P with same curvature\nCentre lies on the normal at distance R"],
        ["Centre of curvature","(x − y'(1+y'²)/y'', y + (1+y'²)/y'')\nCoordinates of the centre of the osculating circle"],
      ]}/>

      <h2 style={S.h2}>Arc Length</h2>
      <DiagramArcLength/>
      <Table2 rows={[
        ["Arc length element","ds = √(dx² + dy²) = √(1 + y'²) dx\nThe infinitesimal chord length from Pythagoras"],
        ["Cartesian arc length","L = ∫ₐᵇ √(1 + (dy/dx)²) dx\nIntegrate from x=a to x=b"],
        ["Parametric arc length","L = ∫ₜ₁ᵗ² √((dx/dt)² + (dy/dt)²) dt\nSpeed = |velocity| = √(x'²+y'²)"],
        ["Polar arc length","L = ∫ₐᵝ √(r² + (dr/dθ)²) dθ\nr is function of angle θ"],
        ["Arc length parameter s","s(t) = ∫₀ᵗ |r'(u)| du\nNatural parametrisation by arc length: |dr/ds| = 1"],
        ["Surface of revolution","S = 2π ∫ y ds  (rotated about x-axis)\n= 2π ∫ₐᵇ y(x) √(1+y'²) dx"],
      ]}/>

      <h2 style={S.h2}>Parametric Curves</h2>
      <DiagramParametric/>
      <Table2 rows={[
        ["Parametric representation","x = x(t),  y = y(t)\nAllows self-intersections, closed curves, and cusps"],
        ["Tangent slope","dy/dx = (dy/dt) / (dx/dt)  provided dx/dt ≠ 0\nUndefined when dx/dt = 0 (vertical tangent)"],
        ["2nd derivative","d²y/dx² = (d/dt [dy/dx]) / (dx/dt)\nUsed to determine concavity in parametric form"],
        ["Cusp","Occurs when x'(t) = y'(t) = 0 simultaneously\nCurve has a corner or sharp point"],
        ["Cycloid","x = r(t−sin t),  y = r(1−cos t)\nArc length of one arch = 8r; area = 3πr²"],
        ["Lissajous figures","x = A sin(nt+φ),  y = B sin(mt)\nClosed when m/n is rational"],
      ]}/>

      <h2 style={S.h2}>Polar Curves</h2>
      <DiagramPolar/>
      <Table2 rows={[
        ["Polar coordinates","Point (r, θ): r = distance from origin, θ = angle from +x axis\nx = r cosθ,  y = r sinθ;  r = √(x²+y²)"],
        ["Area in polar","A = ½ ∫ₐᵝ r² dθ\nArea swept by radius vector from θ=α to θ=β"],
        ["Cardioid","r = a(1 ± cos θ) or r = a(1 ± sin θ)\nArea = (3/2)πa²; has one cusp at origin"],
        ["Rose curve","r = cos(nθ) or r = sin(nθ)\nn petals (n odd); 2n petals (n even)"],
        ["Limaçon","r = a + b cos θ\nInner loop when |a|<|b|; dimple when |a|<2|b|; convex when |a|≥2|b|"],
        ["Lemniscate","r² = a² cos(2θ)\nFigure-of-eight; area = a²"],
        ["Archimedean spiral","r = aθ\nEqual spacing 2πa between successive turns"],
        ["Logarithmic spiral","r = ae^(bθ)\nConstant angle between tangent and radius; self-similar"],
      ]}/>

      <h2 style={S.h2}>Evolute and Involute</h2>
      <DiagramEvoluteInvolute/>
      <Table2 rows={[
        ["Evolute","Locus of centres of curvature of a given curve\nNormals to the original curve are tangents to the evolute"],
        ["Evolute of parabola y=x²","Semicubical parabola: x = −4t³, y = 3t² + ½\nHas a cusp at the vertex of the parabola"],
        ["Evolute of ellipse","Astroid-like curve: x=(a²−b²)cos³t/a,  y=−(b²−a²)sin³t/b"],
        ["Involute","Curve traced by end of taut string unwinding from another curve\nInvolute of evolute = original curve"],
        ["Involute of circle","x = r(cos t + t sin t),  y = r(sin t − t cos t)\nUsed in gear tooth profiles (involute gearing)"],
        ["Envelope of normals","The evolute is the envelope of all normals to a curve\nDistance from curve to evolute along normal = R (radius of curvature)"],
      ]}/>

      <InfoBox title="Key Takeaway — Curvature Quick Reference" items={[
        "Curvature formula (Cartesian): κ = |y''| / (1+y'²)^(3/2)",
        "Radius of curvature: R = 1/κ — the radius of the best-fitting circle",
        "Arc length: L = ∫√(1+y'²) dx  — integrate ds over the curve",
        "Parametric tangent: dy/dx = (dy/dt)/(dx/dt)",
        "Polar area: A = ½∫r² dθ — don't forget the ½!",
        "Inflection point: y''=0 and sign changes — κ passes through zero",
        "Evolute = locus of centres of curvature; involute reverses the process",
        "Circle: κ=1/r constant; Straight line: κ=0; Parabola y=ax²: κ=2|a| at vertex",
      ]}/>
    </div>
  );
}